import React, { useEffect, useRef, useState } from "react";
import specialFiltersConfig from "./specialFilters.config";
import useFlotteFilters from "../useFlotteFilters";
import { isVORole } from "./FlotteUtils";
import { useAtom } from "jotai";
import { connectedUserAtom } from "../../../../../middlewares/AuthMiddleware";
import { columnsAtom } from "./useFlotteTable";

const SpecialFiltersDropdown = () => {
  const [connectedUser] = useAtom(connectedUserAtom);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { flotteFilters, handleChangeFilters, handleClearFilter } =
    useFlotteFilters();
  const [, setColumns] = useAtom(columnsAtom);

  // Fermer le dropdown quand on clique à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const applyForcedColumns = (cols, visible) => {
    if (!cols || cols.length === 0) return;
    setColumns((prev) => {
      const next = { ...prev };
      cols.forEach((key) => {
        if (next[key]) {
          next[key] = { ...next[key], visible };
        }
      });
      return next;
    });
  };

  const handleToggleFilter = (filterKey, value) => {
    const isActive = Boolean(flotteFilters[filterKey]);
    const filterConfig = specialFiltersConfig.find(
      (f) => f.filterKey === filterKey,
    );

    if (isActive) {
      handleClearFilter(filterKey);
      applyForcedColumns(filterConfig?.forceVisibleColumns, false);
    } else {
      handleChangeFilters({
        target: { name: filterKey, value, type: "filter" },
      });
      applyForcedColumns(filterConfig?.forceVisibleColumns, true);
    }
  };

  // Compter les filtres spéciaux actifs
  const activeCount = specialFiltersConfig.filter((f) =>
    Boolean(flotteFilters[f.filterKey]),
  ).length;

  return (
    <div
      style={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      {!isVORole(connectedUser.role) && (
        <button
          className={`btn btn-sm ${activeCount > 0 ? "btn-warning" : "btn-default"}`}
          onClick={() => setIsOpen(!isOpen)}
          type="button"
          style={{
            whiteSpace: "nowrap",
            border: activeCount > 0 ? undefined : "1px solid #dee2e6",
          }}
        >
          <i className="fas fa-filter mr-1"></i>
          Filtres spéciaux
          {activeCount > 0 && (
            <span
              className="badge badge-light ml-1"
              style={{ fontSize: "0.75em" }}
            >
              {activeCount}
            </span>
          )}
          <i className={`fas fa-chevron-${isOpen ? "up" : "down"} ml-2`}></i>
        </button>
      )}

      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            zIndex: 1050,
            minWidth: 250,
            background: "white",
            border: "1px solid #dee2e6",
            borderRadius: "0.375rem",
            boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
            marginTop: 2,
            padding: "0.5rem 0",
          }}
        >
          <div
            style={{
              padding: "0.5rem 1rem",
              borderBottom: "1px solid #dee2e6",
              marginBottom: "0.25rem",
            }}
          >
            <h6
              className="mb-0 text-muted"
              style={{
                fontSize: "0.8rem",
                textTransform: "uppercase",
                letterSpacing: 0.5,
              }}
            >
              <i className="fas fa-magic mr-2"></i>
              Recherches avancées
            </h6>
          </div>

          {specialFiltersConfig.map((filter) => {
            const isActive = Boolean(flotteFilters[filter.filterKey]);
            return (
              <div
                key={filter.filterKey}
                className="px-3 py-2"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  handleToggleFilter(filter.filterKey, filter.value)
                }
              >
                <div className="form-check mb-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={isActive}
                    onChange={() => {}}
                    style={{ cursor: "pointer" }}
                  />
                  <label
                    className="form-check-label"
                    style={{ cursor: "pointer", fontSize: "0.875rem" }}
                  >
                    {filter.icon && (
                      <i
                        className={`fas ${filter.icon} mr-2`}
                        style={{ color: isActive ? "#e67e22" : "#6c757d" }}
                      ></i>
                    )}
                    {filter.title}
                  </label>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SpecialFiltersDropdown;
